/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Commandmanp22Inputs */



/**
* | output |
* | --- |
* | "Right/bottom pump manual command" |
*
* @param {Ahu_History_Key_Commandmanp22Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_commandmanp22 = /** @type {((inputs?: Ahu_History_Key_Commandmanp22Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Commandmanp22Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Right/bottom pump manual command")
	return /** @type {LocalizedString} */ ("Commande manuelle pompe droite/basse")
});
export { ahu_history_key_commandmanp22 as "ahu_history_key_commandManP2" }